/**
 * Il messaggio per un rifiuto del catalogo sport (409 di `/sports` e
 * `/admin/sports`, docs/sport-config Fase 3).
 *
 * Il server risponde con `detail: {code, message, sport?, label?}`: il codice
 * dice **perché** lo sport non si crea (esiste già, è di un collega, è di un
 * altro coach...) e l'interfaccia lo traduce. `fetchAPI` mette quell'oggetto in
 * `error.detail`; `error.message` sarebbe «[object Object]».
 *
 * `variant`: "coach" o "admin" — lo stesso doppione si risolve in modo diverso
 * (il coach lo segue, l'admin lo modifica dalla lista).
 */
const CODE_KEYS = {
	coach: {
		exists_mine: "sdConflictMine",
		exists_team: "sdConflictTeam",
		exists_other: "sdConflictOther",
		exists_global: "sdConflictGlobal",
		exists_inactive: "sdConflictInactive",
		label_taken: "sdConflictLabel",
	},
	admin: {
		exists_global: "sdConflictGlobalAdmin",
		exists_personal: "sdConflictPersonal",
		label_taken: "sdConflictLabel",
	},
};

export function sportConflictCode(error) {
	const detail = error?.detail;
	return detail && typeof detail === "object" ? detail.code || null : null;
}

export function sportConflictMessage(error, t, variant = "coach") {
	const detail = error?.detail;
	const code = sportConflictCode(error);
	const key = code ? CODE_KEYS[variant]?.[code] : null;
	if (key) {
		const sport = detail?.sport;
		return t(key)
			.replace("{label}", sport?.label || detail?.label || sport?.value || "")
			.replace("{owner}", sport?.owner?.name || "");
	}
	if (detail && typeof detail === "object" && detail.message) return detail.message;
	if (typeof detail === "string" && detail) return detail;
	return error?.message || t("error");
}
